import React from 'react'
import NavBar from '../Components/Main/NavBar'
import AccountInfos from '../Components/Account/AccountInfos'
import AccountOrder from '../Components/Account/AccountOrder'
import Footer from '../Components/Main/Footer'
import '../css/Account/Account.css'
import AccountButtons from '../Components/Account/AccountButtons'
import { AuthContext } from '../Context/AuthProvider'
import { useContext } from 'react'
const Account = () => {
  const {isLoggin} = useContext(AuthContext);
  return (
    <div>
        <NavBar/>
        <div className="account-container">
        {isLoggin ? (
          <>
          <AccountInfos/>
          <AccountOrder/>
          </>
          ) : (
            <>
              <AccountButtons/>
            </>
          )}
          </div>
        <Footer/>
    </div>
  )
}

export default Account